<template>
  <div>
    <payments-list-desktop-bridge v-if="isDesktopListLayout" />
    <payments-list-mobile v-else />
    <accounting-doc-view
      v-model="docView.open"
      :item="docView.item"
      @edit="openDocEdit"
      @error="serverErrorHandeler"
    />
    <treasury-receipt-print
      v-if="receiptKind"
      ref="receiptPrint"
      :kind="receiptKind"
      @error="serverErrorHandeler"
    />
    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
    />
    <!--    filter dialog-->
        <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="960"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ paymentsFilterDialogTitle }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">
          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-account-outline</v-icon>
              {{ $t("costFilterParties") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="account"
                :title="$t('account')"
                type="person"
                :filter="true"
                :multiple="true"
              />
              <autocomplete
                v-model="bank"
                :title="$t('bank') + '/' + $t('cash')"
                type="allBankCash"
                :filter="true"
                :multiple="true"
              />
              <autocomplete
                v-model="currencyFilter"
                :title="$t('currency')"
                type="currency"
                :filter="true"
                :multiple="true"
              />
              <tag v-model="tag" />
              <autocomplete
                v-model="accountCategory"
                :title="$t('accountCategory')"
                type="accountCategory"
                :multiple="true"
                :filter="true"
              />
              <autocomplete
                v-model="registerar"
                :title="$t('registerar')"
                type="partners"
                :multiple="true"
                :filter="true"
              />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-calendar-range</v-icon>
              {{ $t("accFilterDateTime") }}
            </div>
            <div class="acf-grid acf-grid--4">
              <div>
                <v-text-field
                  id="fromId"
                  v-model="fromDate"
                  :label="$t('from') + ' ' + $t('date')"
                  prepend-inner-icon="mdi-calendar-start"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="fromDate"
                  element="fromId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="toId"
                  v-model="toDate"
                  :label="$t('until') + ' ' + $t('date')"
                  prepend-inner-icon="mdi-calendar-end"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="toDate"
                  element="toId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  :min="fromDate"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="fromTime"
                  v-model="fromTime"
                  :label="$t('from-hour')"
                  prepend-inner-icon="mdi-clock-start"
                  outlined
                  dense
                  clearable
                  readonly
                  hide-details
                />
                <date-picker
                  v-model="fromTime"
                  element="fromTime"
                  type="time"
                  :locale="$store.state.date_locale"
                  :format="'HH:mm'"
                  :display-format="'HH'"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="toTime"
                  v-model="toTime"
                  :label="$t('to-hour')"
                  prepend-inner-icon="mdi-clock-end"
                  outlined
                  dense
                  clearable
                  readonly
                  hide-details
                />
                <date-picker
                  v-model="toTime"
                  element="toTime"
                  type="time"
                  :locale="$store.state.date_locale"
                  :format="'HH:mm'"
                  :display-format="'HH'"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <money
                v-model="fromAmount"
                :dense="true"
                :label="$t('from') + ' ' + $t('amount')"
                :outlined="true"
                :solo="false"
                :clearable="true"
                value-when-is-empty=""
                :options="options"
                class="dense"
              />
              <money
                v-model="toAmount"
                :dense="true"
                :label="$t('until') + ' ' + $t('amount')"
                :outlined="true"
                :solo="false"
                :clearable="true"
                value-when-is-empty=""
                :options="options"
                class="dense"
              />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-office-building-outline</v-icon>
              {{ $t("sellFilterOrg") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="branch"
                title="branch"
                type="branch"
                :filter="true"
                :multiple="true"
              />
              <v-select
                v-model="lockStatus"
                :label="$t('lockStatusDocuments')"
                :items="lockStatusItems"
                dense
                outlined
                clearable
                hide-details
                item-value="value"
                item-text="text"
              />
              <v-select
                v-model="selectedHeaders"
                :items="headers"
                :label="$t('sellFilterColumns')"
                dense
                outlined
                multiple
                return-object
                hide-details
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum(selectedHeaders.length - 1) }}
                  </span>
                </template>
              </v-select>
            </div>
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getItems">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
<v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--    delete dialog-->
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="uploadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            :type-prop="type == 'recieve' ? 'recieve' : type == 'pay' ? 'pay' : ''"
            :get-item="uploadDialog"
            @close="uploadDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    print dialog-->
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :items-prop="items"
            :dialog="printDialog"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <snakbar v-model="snakbar" :text="snakbarText" :active="snakbar" />
  </div>
</template>


<script>
import Task from "../task/task";
import Upload from "../../components/general/upload/upload";
import General from "../../../../Mixins/general";
import {
  applyColumnSettings,
  loadColumnSettings,
} from "@/plugins/columnSettings/columnSettings";
import { reorderPinnedHeaders } from "@/plugins/columnPin/columnPin";
import autocomplete from "../../components/general/patial/autocomplete";
import PaymentsListDesktopBridge from "./layouts/desktop/PaymentsListDesktopBridge.vue";
import PaymentsListMobile from "./layouts/mobile/PaymentsListMobile.vue";
import Vue from "vue";
import TreasuryReceiptPrint from "./layouts/TreasuryReceiptPrint.vue";
import AccountingDocView from "@/views/dashboard/pages/accounting/layouts/AccountingDocView.vue";
import ProList from "@/Mixins/proList";
import PrintStudio from "@/modules/print/PrintStudio.vue";
import ProListFrame from "@/components/proList/ProListFrame.vue";
export default {
  name: "PaymentList",
  provide() {
    return { paymentsList: this };
  },
  components: {
    ProListFrame,
    PrintStudio,
    PaymentsListDesktopBridge,
    PaymentsListMobile,
    TreasuryReceiptPrint,
    AccountingDocView,
    Snakbar: () => import("../../components/general/snakbar/snakbar"),
    Tag: () => import("../../components/general/Tag/tag"),
    dialogComponent: () => import("../../components/general/dialog/index"),
    autocomplete,
    Task,
    Upload,
  },
  mixins: [General, ProList],
  props: ["input", "refId", "mobileShow"],
  data: () => ({
    printHeaders: [],
    selected: [],
    printDialog: false,
    deletDialog: false,
    excelItems: [],
    accountCategory: null,
    summary: null,
    listViewportObserver: null,
    listViewportRaf: null,
    account: null,
    pageCount: 1,
    page: 1,
    currencyFilter: null,
    bank: null,
    toAmount: null,
    fromAmount: null,
    fromDate: null,
    uploadDialog: false,
    toDate: null,
    dialogData: null,
    typeForm: null,
    showSelect: true,
    filter: false,
    model: null,
    from: 1,
    taskDialog: null,
    type: null,
    registerar: null,
    tag: null,
    temp: null,
    deleteItem: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    taskId: null,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    // Separate from General mixin money `options` (beforeMount overwrites it).
    tableOptions: {
      page: 1,
      itemsPerPage: 10,
    },
    headers: null,
    selectedHeaders: [],
    search: null,
    fromTime: null,
    toTime: null,
  }),
  // UI-only state outside data() (list payloads must stay clean).
  created() {
    this.docView = Vue.observable({ open: false, item: null });
  },
  computed: {

    paymentsFilterDialogTitle() {
      if (this.$route.name === "recieveList") return this.$t("receiveFilterTitle");
      if (this.$route.name === "removedPayments") return this.$t("removedPaymentsFilterTitle");
      return this.$t("payFilterTitle");
    },
    activeFilterChips() {
      var app = this;
      var has = function (v) {
        if (Array.isArray(v)) return v.length > 0;
        return v !== null && v !== undefined && v !== "" && v !== "0" && v !== 0;
      };
      var show = function (v) {
        if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0]);
        if (v && typeof v === "object") return v.name || v.text || v.label || "";
        return typeof v === "number" || typeof v === "string" ? String(v) : "";
      };
      var pick = function (items, v, key) {
        var arr = Array.isArray(v) ? v : [v];
        return arr
          .map(function (x) {
            var f = (items || []).find(function (i) {
              return i.value === x;
            });
            return f ? f[key || "text"] : "";
          })
          .filter(Boolean)
          .join("، ");
      };
      var defs = [
        ["account", app.$t("account")],
        ["bank", app.$t("bank") + "/" + app.$t("cash")],
        ["currencyFilter", app.$t("currency")],
        ["tag", app.$t("tag")],
        ["accountCategory", app.$t("accountCategory")],
        ["registerar", app.$t("registerar")],
        ["fromDate", app.$t("from") + " " + app.$t("date")],
        ["toDate", app.$t("until") + " " + app.$t("date")],
        ["fromTime", app.$t("from-hour")],
        ["toTime", app.$t("to-hour")],
        ["fromAmount", app.$t("from") + " " + app.$t("amount")],
        ["toAmount", app.$t("until") + " " + app.$t("amount")],
        ["branch", app.$t("branch")],
        ["lockStatus", app.$t("lockStatusDocuments"), pick(app.lockStatusItems, app.lockStatus)],
      ];
      return defs
        .filter(function (d) {
          return has(app[d[0]]);
        })
        .map(function (d) {
          return { key: d[0], label: d[1], value: d.length > 2 ? d[2] : show(app[d[0]]) };
        });
    },
    receiptKind() {
      if (this.type === "pay") return "cashPay";
      if (this.type === "recieve") return "cashReceive";
      return "";
    },
    proListKey() {
      return this.paymentsListColumnPersistKey;
    },
    proListLocked() {
      return this.paymentsListLockedColumns;
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    isDesktopListLayout() {
      if (this.mobileShow) return true;
      return this.$vuetify.breakpoint.width >= 800;
    },
    isDesktopListViewport() {
      return !this.isMobile && !this.mobileShow;
    },
    paymentsListColumnPersistKey() {
      return "treasury-payments-list-columns-" + (this.$route.name || "payList");
    },
    paymentsListLockedColumns() {
      // Fixed sticky block: select + actions + id + document number (no unpin/drag)
      var locked = ["actions", "id", "doc_header.number"];
      return this.showSelect ? ["__select"].concat(locked) : locked;
    },
    paymentsListColumnPlugins() {
      // show-select inserts a leading checkbox <th>; pad visibleHeaders so
      // pin/resize/drag index mapping stays aligned with thead cells.
      var selectHeader = {
        value: "__select",
        text: "",
        width: 32,
        sortable: false,
        pinned: false,
        originalIndex: -1,
      };
      var visible = this.showSelect
        ? [selectHeader].concat(this.tableHeaders || [])
        : this.tableHeaders || [];
      return {
        headers: this.headers,
        visibleHeaders: visible,
        locked: this.paymentsListLockedColumns,
        anchor: "doc_header.number",
        minWidth: 60,
        persistKey: this.paymentsListColumnPersistKey,
      };
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        return app.selectedHeaders.includes(s);
      });
    },
    totals: function () {
      const totals = this.items.reduce(
        (acc, d) => {
          acc.amount += parseFloat(d.amount);
          return acc;
        },
        {
          amount: 0,
        }
      );
      return totals;
    },
  },
  watch: {
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      this.model = this.selected[0]?.text;
      this.temp = this.selected[0]?.text;
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    tableOptions: {
      handler() {
        var app = this;
        app.sortBy = [];
        const sortBy = (app.tableOptions && app.tableOptions.sortBy) || [];
        sortBy.forEach(function (value) {
          const index = (app.headers || []).findIndex((h) => h.value === value);
          if (index > -1 && app.headers[index].table) {
            app.sortBy.push(app.headers[index].table);
          }
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    summary() {
      if (this.isDesktopListViewport) {
        this.scheduleDesktopTableHeightUpdate();
      }
    },
    loading(val) {
      if (!val && this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      }
    },
    isDesktopListViewport(val) {
      if (val) {
        this.$nextTick(() => {
          this.updateDesktopTableHeight();
          this.bindListViewportObserver();
        });
      } else {
        this.unbindListViewportObserver();
        this.tableHeight = window.innerHeight - 245;
      }
    },
  },
  activated() {
    // this.getItems()
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.scheduleDesktopTableHeightUpdate();
      });
    }
  },
  beforeMount() {
    if (this.$route.name === "payList") {
      this.type = "pay";
    }
    if (this.$route.name === "removedPayments") {
      this.type = "removedPayments";
    }
    if (this.$route.name === "recieveList") {
      this.type = "recieve";
    }
    this.headers = [
      {
        text: this.$t("#"),
        align: "center",
        sortable: false,
        value: "actions",
        width: 42,
        class: "pl-action-col",
        cellClass: "pl-action-col",
      },
      {
        text: this.$t("number") + " " + this.$t(this.type),
        sortable: true,
        value: "id",
        table: "payments.id",
      },
      {
        text: this.$t("document-number"),
        sortable: true,
        value: "doc_header.number",
        table: "doc_header.number",
      },
      {
        text: this.$t("account"),
        sortable: false,
        value: "account.name",
      },
      {
        text: this.$t("bank") + " / " + this.$t("cash"),
        sortable: false,
        value: "bank.name",
      },
      {
        text: this.$t("amount"),
        sortable: true,
        value: "amount",
        table: "payments.amount",
      },
      {
        text: this.$t("date"),
        sortable: true,
        value: "date",
        table: "payments.date",
      },
      {
        text: this.$t("branch"),
        sortable: false,
        value: "branch.name",
      },
      {
        text: this.$t("issueTracking"),
        sortable: true,
        value: "issue_tracking",
        table: "payments.issue_tracking",
      },
      {
        text: this.$t("relation-whit"),
        sortable: false,
        value: "relations",
      },
      {
        text: this.$t("tag"),
        sortable: false,
        value: "tags",
      },
      {
        text: this.$t("description"),
        sortable: true,
        value: "content",
        table: "payments.content",
      },
      {
        text: this.$t("registerar"),
        sortable: false,
        value: "user.name",
      },
    ];
    this.printHeaders = [
      {
        text: this.$t("number") + " " + this.$t(this.type),
        value: "id",
      },
      {
        text: this.$t("account"),
        value: "account.name",
      },
      {
        text: this.$t("bank") + " / " + this.$t("cash"),
        value: "bank.name",
      },
      {
        text: this.$t("amount"),
        value: "amount",
        sum: true,
        type: "number",
      },
      {
        text: this.$t("date"),
        value: "date",
      },
      {
        text: this.$t("branch"),
        value: "branch.name",
      },
      {
        text: this.$t("issueTracking"),
        value: "issue_tracking",
      },
      {
        text: this.$t("description"),
        value: "content",
      },
    ];

    this.selectedHeaders = this.headers;
    if (this.input) {
      this.model = this.input;
    }
    reorderPinnedHeaders(this.headers, {
      locked: this.paymentsListLockedColumns,
      anchor: "doc_header.number",
    });
    this.loadPaymentsListColumnSettings();
  },
  mounted() {
    this.getItems();
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.updateDesktopTableHeight();
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      });
    }
  },
  deactivated() {
    this.unbindListViewportObserver();
  },
  beforeDestroy() {
    this.unbindListViewportObserver();
    if (this.listViewportRaf) {
      cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = null;
    }
  },
  methods: {

    resetFilters() {
      var app = this;
      [
        "account", "bank", "currencyFilter", "tag", "accountCategory", "registerar",
        "fromDate", "toDate", "fromTime", "toTime", "fromAmount", "toAmount",
        "branch", "lockStatus",
      ].forEach(function (k) {
        app[k] = null;
      });
    },
    // View the linked accounting document (same dialog as the accounting list).
    viewDocument(item) {
      var id = item && (item.doc_head_id || (item.doc_header && item.doc_header.id));
      if (!id) return;
      this.docView.item = { id: id, lock: item.lock };
      this.docView.open = true;
    },
    openDocEdit(doc) {
      this.docView.open = false;
      this.$router.push({ name: "accountingEdit", params: { id: doc.id } });
    },
    // Printed receipt (single row or group, list order) via the print module.
    receiptPrint(item, picked) {
      var list = item ? [item] : (picked || this.selected || []).slice();
      if (!list.length || !this.receiptKind) return;
      var order = this.items || [];
      var pos = function (x) {
        var i = order.findIndex(function (r) { return r.id === x.id; });
        return i < 0 ? Number.MAX_SAFE_INTEGER : i;
      };
      list.sort(function (a, b) { return pos(a) - pos(b); });
      this.$refs.receiptPrint.open(list);
    },
    resolveRefEl(ref) {
      if (!ref) return null;
      return ref.$el || ref;
    },
    onResize() {
      if (this.isDesktopListViewport) {
        this.updateDesktopTableHeight();
        return;
      }
      this.tableHeight = window.innerHeight - 245;
    },
    scheduleDesktopTableHeightUpdate() {
      if (this.listViewportRaf) cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = requestAnimationFrame(() => {
        this.listViewportRaf = null;
        this.updateDesktopTableHeight();
      });
    },
    updateDesktopTableHeight() {
      if (!this.isDesktopListViewport) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const toolbarEl = this.resolveRefEl(this.$refs.listToolbar);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      if (!rootEl || !tableColEl) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootStyle = window.getComputedStyle(rootEl);
      const rootPadding =
        (parseFloat(rootStyle.paddingTop) || 0) +
        (parseFloat(rootStyle.paddingBottom) || 0);
      const toolbarHeight = toolbarEl ? toolbarEl.offsetHeight : 0;
      let summaryHeight = 0;
      if (summaryEl) {
        const summaryVisible =
          summaryEl.offsetParent !== null ||
          summaryEl.getClientRects().length > 0;
        if (summaryVisible) {
          const summaryStyle = window.getComputedStyle(summaryEl);
          summaryHeight =
            summaryEl.offsetHeight +
            (parseFloat(summaryStyle.marginTop) || 0) +
            (parseFloat(summaryStyle.marginBottom) || 0);
        }
      }
      const colStyle = window.getComputedStyle(tableColEl);
      const colPadding =
        (parseFloat(colStyle.paddingTop) || 0) +
        (parseFloat(colStyle.paddingBottom) || 0);
      const footerEl = tableEl
        ? tableEl.querySelector(".v-data-footer")
        : null;
      const footerHeight = footerEl ? footerEl.offsetHeight : 0;
      const tableStyle = tableEl ? window.getComputedStyle(tableEl) : null;
      const tableMargins = tableStyle
        ? (parseFloat(tableStyle.marginTop) || 0) +
          (parseFloat(tableStyle.marginBottom) || 0)
        : 0;
      const available =
        rootEl.clientHeight -
        rootPadding -
        toolbarHeight -
        summaryHeight -
        colPadding -
        footerHeight -
        tableMargins -
        3;
      this.tableHeight = Math.max(180, Math.floor(available));
    },
    bindListViewportObserver() {
      if (typeof ResizeObserver === "undefined") return;
      this.unbindListViewportObserver();
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      const footerEl = tableEl ? tableEl.querySelector(".v-data-footer") : null;
      if (!rootEl && !summaryEl && !tableColEl) return;
      this.listViewportObserver = new ResizeObserver(() => {
        this.scheduleDesktopTableHeightUpdate();
      });
      if (rootEl) this.listViewportObserver.observe(rootEl);
      if (summaryEl) this.listViewportObserver.observe(summaryEl);
      if (tableColEl) this.listViewportObserver.observe(tableColEl);
      if (footerEl) this.listViewportObserver.observe(footerEl);
    },
    unbindListViewportObserver() {
      if (this.listViewportObserver) {
        this.listViewportObserver.disconnect();
        this.listViewportObserver = null;
      }
    },
    loadPaymentsListColumnSettings() {
      var app = this;
      if (!app.headers || !app.headers.length) return;
      loadColumnSettings(app, app.paymentsListColumnPersistKey).then(function (snapshot) {
        if (!snapshot || !snapshot.length) return;
        applyColumnSettings(app.headers, snapshot, {
          locked: app.paymentsListLockedColumns,
          anchor: "doc_header.number",
        });
        app.$forceUpdate();
      });
    },
    // add unlock group send type
    unlockGroup(type = "unlock") {
      this.lockGroup(type);
    },
    lock(item, type) {
      if (this.$store.state.userCurrentPlan != null) {
        const lockItem = this.$store.state.userCurrentPlan.plan.options.find(
          (item) => item.key == "lockSystem"
        );
        if (lockItem && lockItem.value == "deactive") {
          this.$store.commit("SET_PLAN_DIALOG", true);
          this.$router.replace("/");
        } else {
          this.selected = [item];
          this.lockGroup(type);
        }
      }
    },
    lockGroup(type) {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "payments", {
          params: {
            lock: "active",
            id: selected,
            type: type,
          },
        })
        .then((res) => {
          res = res.data;
          app.snakbarText = this.$t("opertationSuccess");
          app.snakbarColor = "green";
          app.snakbar = true;
          app.getItems();
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(function () {
          app.loading = false;
          app.selected = [];
        });
    },
    openComponent(component, id) {
      this.dialogData = {
        name: component,
        id: id,
      };
      this.innerComponent = true;
    },
    openTurnover(prop) {
      this.$router.push({ name: "turnover", params: { accountProp: prop } });
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      if (item.lock) {
        return false;
      }
      this.$router.push({ name: this.type + "Edit", params: { id: item.id } });
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.filter = false;
      app.$axios
        .get(this.$endpoint + "payments", {
          params: {
            search: app.search,
            account: app.account,
            bank: app.bank,
            branch: app.branch,
            fromDate: app.fromDate,
            toDate: app.toDate,
            accountCategory: app.accountCategory,
            registerar: app.registerar,
            fromAmount: app.fromAmount,
            toAmount: app.toAmount,
            typeForm: app.typeForm,
            currency: app.currencyFilter,
            page: app.allRows ? app.excelPage : (app.tableOptions && app.tableOptions.page) || 1,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            options: app.tableOptions,
            lockStatus: app.lockStatus,
            tag: app.tag,
            status: app.sellStatus,
            fromTime: app.fromTime,
            toTime: app.toTime,
          },
        })
        .then((res) => {
          res = res.data;
          if (!app.allRows) {
            app.items = res.data;
            app.totalItems = res.total;
            app.pageCount = res.last_page;
            app.from = res.from;
            app.summary = res.summary;
            app.creatExcelData(res.data);
          } else {
            app.generateExcellForAllData(res.data, res.last_page);
          }
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(function () {
          app.loading = false;
          app.selected = [];
        });
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "payments/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.getItems();
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(function () {
          app.deletDialog = false;
          app.loading = false;
          app.selected = [];
          app.deleteItem = null;
        });
    },
    removegroup() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push({ id: value.id });
      });
      app.$axios
        .get(this.$endpoint + "payments", {
          params: {
            deleteItems: selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.getItems();
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(function () {
          app.deletDialog = false;
          app.loading = false;
          app.selected = [];
          app.deleteItem = null;
        });
    },
    refreshRemovedItem() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "payments", {
          params: {
            refreshRemovedInvoices: "active",
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.getItems();
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(function () {
          app.loading = false;
          app.selected = [];
        });
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        app.excelItems.push({
          type: app.$t(d.type),
          id: d.id,
          account: d.account ? d.account.name : null,
          bank: d.bank ? d.bank.name : null,
          date: d.date,
          content: d.content ? d.content : "",
          issueTracking: d.issue_tracking,
          amount: app.$numberFormat(d.amount),
          relations:
            d.relations && d.relations.length > 0
              ? d.relations[0].name + " -id : " + d.relations[0].id
              : "",
          tags: d.tags ? d.tags.map((item) => item.text).join(",") : "",
          user: d.user ? d.user.name : "",
        });
      });
    },
    openUploadDialog(item) {
      if (
        this.$root &&
        (this.type === "recieve" || this.type === "pay")
      ) {
        this.$root.$emit("open-user-file-process", { type: this.type });
      }
    },
  },
};
</script>

<style scoped lang="scss">
/* Desktop chrome: shared pro-list kit (slot content of ProListFrame) */
@import "~@/sass/design-system/list/pro-list";

::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
</style>
